// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/conti-analitici?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, parentId, divisioneId, livello, codice, descrizione, natura, attivo, figli }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/divisioni-analitiche?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, codice, descrizione, colore, attivo }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/divisioni-analitiche',
    requestBody: '{ societaId, codice, descrizione }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/divisioni-analitiche/:id',
    requestBody: '{ codice, descrizione, attivo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/divisioni-analitiche/:id',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/conti-analitici',
    requestBody: '{ societaId, parentId, divisioneId, descrizione, natura }',
    response: '{ success: true, data: { id, codice, livello, natura } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/conti-analitici/:id',
    requestBody: '{ descrizione, natura, divisioneId, attivo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/conti-analitici/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
